module.exports = __webpack_public_path__ + "img/Slagboom-met-pijl.e3693819.svg";